import { publicRequest } from '@/utils/request'

/** 添加类目收藏 */
export function addCategoryCollection(data) {
  return publicRequest({
    url: '/member/categoryCollection/add',
    method: 'post',
    data
  })
}

/** 取消类目收藏 */
export function deleteCategoryCollection(categoryId) {
  return publicRequest({
    url: '/member/categoryCollection/delete',
    method: 'post',
    params: { categoryId }
  })
}

/** 类目收藏详情（是否已收藏） */
export function getCategoryCollectionDetail(categoryId) {
  return publicRequest({
    url: '/member/categoryCollection/detail',
    method: 'get',
    params: { categoryId }
  })
}

/** 当前用户全部类目收藏 */
export function listAllCategoryCollections() {
  return publicRequest({
    url: '/member/categoryCollection/listAll',
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/categoryCollection.js